// Handle of the app embed block: extensions/tinyalbert-forms/blocks/tinyalbert_form.liquid in tinyalbert-shopify.
const EMBED_BLOCK_HANDLE = "tinyalbert_form";

const SHOP_DOMAIN = /^[a-z0-9][a-z0-9-]*\.myshopify\.com$/;

// Theme editor deep link that opens the App embeds panel with the tinyAlbert embed switched on. The merchant still
// has to click Save. activateAppId is the app's client id (API key), not the extension id.
export function buildActivationUrl(
  shop: string | undefined,
  clientId: string | undefined
): string | null {
  const domain = shop?.trim().toLowerCase();
  if (!domain || !SHOP_DOMAIN.test(domain) || !clientId) {
    return null;
  }
  return `https://${domain}/admin/themes/current/editor?context=apps&activateAppId=${encodeURIComponent(
    clientId
  )}/${EMBED_BLOCK_HANDLE}`;
}
